var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("textarea", {
    staticClass:
      "placeholder-italic focus:outline-none focus:shadow-none rounded disabled:bg-input-disabled disabled:border-gray-200",
    class: _vm.styles,
    attrs: {
      name: _vm.name,
      rows: _vm.rows,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      id: "newNote",
    },
    domProps: { value: _vm.value },
    on: {
      input: _vm.handleInput,
      keydown: function ($event) {
        return _vm.$emit("keydown", $event)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }